import { create } from 'zustand'

interface IMapLocation {
    latitude: number
    longitude: number
    timestamp?: number
}

interface IMapLocationStore {
    targetLocation: IMapLocation | null
    setTargetLocation: (location: IMapLocation) => void
    clearTargetLocation: () => void
    consumeTargetLocation: () => IMapLocation | null
}

export const useMapLocationStore = create<IMapLocationStore>((set, get) => ({
    targetLocation: null,
    setTargetLocation: (location: IMapLocation) => {
        set({ targetLocation: { ...location, timestamp: Date.now() } })
    },
    clearTargetLocation: () => {
        set({ targetLocation: null })
    },
    consumeTargetLocation: () => {
        const location = get().targetLocation
        set({ targetLocation: null })
        return location
    }
})) 
